import React,{Component} from 'react';
import {Avatar} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
const styles={

};
class DealsAppView extends Component{
  constructor (){
    super();
    this.state={
      deals:{},
      user:{}
    }
  }
  componentDidMount(){
    let {deals}=this.props;
    this.setState({deals:deals});
  }
  // componentWillReceiveProps(nextProps){
  //   this.setState({deals:nextProps.dealsData,
  //   user:nextProps.user})
  // }
  checkProfileImg=(url)=>{
    const {user}=this.props;
    if(url=== null || url==="" ){
      return <img  src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} height={50} width={50}/>
    }else{
      return <img src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${url}`} height={50} width={50}/>
    }
  };
  render(){
    const {deals}=this.props;
    const {user}=this.props;
    return(
      <div>
      {deals &&<div className="description-title">
        <h5>Live Preview of what customers will show you to claim offer</h5>
        <Avatar className="avatar">
         {this.checkProfileImg(user.results.AppUser.ProfileImage)}

        </Avatar>
        <div className="deal-title">
          <h2>{deals.Title}</h2>
          <h6>{deals.Description && deals.Description}</h6>
          <p>{'*Not valid with any other offers or promotional discounts.'}</p>
          <p className="deal-expires">{`Expires: ${moment(deals.EndDate).format('MMM Do, YYYY')}`}</p>
          <h5>{'Offer Code: XXXXXX'}</h5>
          <p>{'Show this screen to claim this deal'}</p>
        </div>
      </div>}
      </div>
    )
  }
}
export default withStyles(styles)(DealsAppView);